import { setShowReadingPane } from 'owa-mail-layout';
import { orchestrator } from 'satcheljs';
import { default as activateTab } from './activateTab';
import { primaryTab } from '../store/tabStore';

orchestrator(setShowReadingPane, () => {
    // Whenever show/hide reading pane, it means we are operating on the primary tab
    activateTab(primaryTab);
});
